import Webapi from './webapi'
import auth from '../auth'

const contentType = 'application/vnd.budbee.terminal-sorting-v2+json'

const webapi = () =>
    new Webapi()
        .authorization(auth.get())
        .accept(contentType)
        .contentType(contentType)
        .path('terminals')

export const backorderNonVerifiedParcels = (terminalId) =>
    webapi()
        .path(terminalId)
        .path('sorting/backorder-non-verified-parcels')
        .queryParam('dryRun', false)
        .post()

export const getBackorderNonVerifiedParcels = (terminalId) =>
    webapi()
        .path(terminalId)
        .path('sorting/backorder-non-verified-parcels')
        .queryParam('dryRun', true)
        .post()

export const getTerminalLoadingSlots = (terminalId, date) =>
    webapi()
        .path(terminalId)
        .path('loading-slots')
        .path(date)
        .get()
